import React, { useEffect, useRef } from 'react';
import './AdStyles.css';

const AdComponent = ({ adSlot, adFormat }) => {
  const adContainerRef = useRef(null);
  
  useEffect(() => {
    if (window.adsbygoogle) {
      try {
        // Push the ad only if the container exists
        if (adContainerRef.current) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
      } catch (e) {
        console.error('AdSense error:', e);
      }
    } else {
      console.warn('AdSense not loaded yet');
    }
  }, []);

  return (
    <div className="ad-container" ref={adContainerRef}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-1891450073668050" // Replace with your publisher ID
        data-ad-slot={adSlot}
        data-ad-format={adFormat || 'auto'}
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default AdComponent;